// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-page {
  padding: 110px 0 80px;
  min-height: 70vh;
  background: linear-gradient(180deg, var(--section-light-gray) 0%, var(--bg-white) 100%);
}

.portal-inner h1 {
  text-align: center;
  color: var(--primary-dark-blue);
  margin-bottom: 0.5rem;
}

.portal-subtitle {
  text-align: center;
  color: var(--footer-medium-gray);
  margin-bottom: 2rem;
}

.portal-card {
  max-width: 440px;
  margin: 0 auto;
  background: var(--bg-white);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 32px var(--shadow-color);
  border-top: 4px solid var(--secondary-light-gold);
}

.portal-login label {
  display: block;
  margin-bottom: 1rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
}

.portal-login input {
  width: 100%;
  margin-top: 0.35rem;
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-light);
  border-radius: 10px;
  font-family: inherit;
  font-size: 1rem;
}

.portal-login .btn {
  width: 100%;
  margin-top: 0.5rem;
}

.portal-error {
  color: #dc2626;
  font-size: 0.9rem;
  margin: 0.5rem 0;
}

.portal-demo {
  margin-top: 1rem;
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
  text-align: center;
}

.portal-back {
  display: block;
  text-align: center;
  margin-top: 1.25rem;
  color: var(--button-medium-blue);
  text-decoration: none;
}

.portal-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.portal-shipment-list {
  display: grid;
  gap: 1.25rem;
}

.portal-shipment-card {
  background: var(--bg-white);
  border-radius: 14px;
  padding: 1.5rem;
  box-shadow: 0 6px 20px var(--shadow-color);
  border-right: 4px solid var(--accent-teal);
}

.portal-shipment-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.portal-declaration {
  font-weight: 700;
  color: var(--primary-dark-blue);
  font-size: 1.05rem;
}

.portal-client-code {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
  color: var(--accent-teal, #0f766e);
  background: rgba(15, 118, 110, 0.1);
  padding: 0.2rem 0.55rem;
  border-radius: 4px;
}

.portal-status-badge {
  background: rgba(37, 99, 235, 0.12);
  color: var(--button-medium-blue);
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
}

.portal-updated {
  font-size: 0.85rem;
  color: var(--footer-medium-gray);
  margin: 0.5rem 0;
}

.portal-empty {
  text-align: center;
  color: var(--footer-medium-gray);
  padding: 2rem;
}

.admin-form {
  max-width: 100%;
  margin-bottom: 2rem;
}

.admin-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin: 1rem 0;
}

.admin-form-grid input {
  padding: 0.65rem 0.85rem;
  border: 2px solid var(--border-light);
  border-radius: 8px;
  font-family: inherit;
}

.admin-status-select {
  display: block;
  margin-top: 1rem;
  font-weight: 600;
}

.admin-status-select select {
  display: block;
  width: 100%;
  margin-top: 0.35rem;
  padding: 0.5rem;
  border-radius: 8px;
  border: 2px solid var(--border-light);
  font-family: inherit;
}

.admin-page .portal-inner {
  max-width: 960px;
}

.portal-loading {
  text-align: center;
  padding: 4rem 1rem;
  color: var(--footer-medium-gray);
  font-size: 1.1rem;
}

.portal-info {
  color: #047857;
  font-size: 0.9rem;
  margin: 0.5rem 0;
  text-align: center;
}

.portal-forgot {
  display: block;
  width: 100%;
  margin-top: 0.75rem;
  background: none;
  border: none;
  color: var(--button-medium-blue);
  cursor: pointer;
  font-family: inherit;
  text-decoration: underline;
}

.portal-toolbar {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.portal-toolbar input,
.portal-toolbar select {
  padding: 0.7rem 0.9rem;
  border: 2px solid var(--border-light);
  border-radius: 10px;
  font-family: inherit;
  font-size: 0.95rem;
}

.portal-detail-link {
  display: inline-block;
  margin-top: 1rem;
  text-decoration: none;
}

.portal-detail {
  max-width: 860px;
}

.portal-back-inline {
  display: inline-block;
  margin-bottom: 1.25rem;
  color: var(--button-medium-blue);
  text-decoration: none;
}

.portal-detail-header {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.portal-detail-title {
  margin: 0.2rem 0 0;
  font-size: 1.75rem;
  color: var(--primary-dark-blue);
}

.portal-detail-meta {
  margin-bottom: 1.5rem;
}

.portal-status-badge-lg {
  font-size: 1rem;
  padding: 0.4rem 1rem;
}

.highlight-update {
  font-weight: 600;
  color: var(--primary-dark-blue);
}

.admin-edit-btn {
  margin-top: 0.75rem;
}

.admin-edit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.6rem;
  margin: 0.75rem 0;
}

.admin-edit-grid input,
.admin-status-select input {
  width: 100%;
  margin-top: 0.35rem;
  padding: 0.55rem 0.75rem;
  border: 2px solid var(--border-light);
  border-radius: 8px;
  font-family: inherit;
}

.document-panel {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}

.document-panel-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

.document-panel-head h2 {
  margin: 0;
  font-size: 1.15rem;
}

.document-upload-btn {
  cursor: pointer;
}

.document-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.75rem;
}

.document-item {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.85rem 1rem;
  background: var(--section-light-gray);
  border-radius: 10px;
}

.document-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

@media (max-width: 640px) {
  .portal-toolbar {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PortalPages.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uFAAuF;AACzF;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;EAChC,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;EACrC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".portal-page {\n  padding: 110px 0 80px;\n  min-height: 70vh;\n  background: linear-gradient(180deg, var(--section-light-gray) 0%, var(--bg-white) 100%);\n}\n\n.portal-inner h1 {\n  text-align: center;\n  color: var(--primary-dark-blue);\n  margin-bottom: 0.5rem;\n}\n\n.portal-subtitle {\n  text-align: center;\n  color: var(--footer-medium-gray);\n  margin-bottom: 2rem;\n}\n\n.portal-card {\n  max-width: 440px;\n  margin: 0 auto;\n  background: var(--bg-white);\n  padding: 2rem;\n  border-radius: 16px;\n  box-shadow: 0 10px 32px var(--shadow-color);\n  border-top: 4px solid var(--secondary-light-gold);\n}\n\n.portal-login label {\n  display: block;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n.portal-login input {\n  width: 100%;\n  margin-top: 0.35rem;\n  padding: 0.75rem 1rem;\n  border: 2px solid var(--border-light);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 1rem;\n}\n\n.portal-login .btn {\n  width: 100%;\n  margin-top: 0.5rem;\n}\n\n.portal-error {\n  color: #dc2626;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n}\n\n.portal-demo {\n  margin-top: 1rem;\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n  text-align: center;\n}\n\n.portal-back {\n  display: block;\n  text-align: center;\n  margin-top: 1.25rem;\n  color: var(--button-medium-blue);\n  text-decoration: none;\n}\n\n.portal-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.portal-shipment-list {\n  display: grid;\n  gap: 1.25rem;\n}\n\n.portal-shipment-card {\n  background: var(--bg-white);\n  border-radius: 14px;\n  padding: 1.5rem;\n  box-shadow: 0 6px 20px var(--shadow-color);\n  border-right: 4px solid var(--accent-teal);\n}\n\n.portal-shipment-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.portal-declaration {\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  font-size: 1.05rem;\n}\n\n.portal-client-code {\n  font-weight: 700;\n  font-size: 0.9rem;\n  letter-spacing: 0.02em;\n  color: var(--accent-teal, #0f766e);\n  background: rgba(15, 118, 110, 0.1);\n  padding: 0.2rem 0.55rem;\n  border-radius: 4px;\n}\n\n.portal-status-badge {\n  background: rgba(37, 99, 235, 0.12);\n  color: var(--button-medium-blue);\n  padding: 0.25rem 0.75rem;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.portal-updated {\n  font-size: 0.85rem;\n  color: var(--footer-medium-gray);\n  margin: 0.5rem 0;\n}\n\n.portal-empty {\n  text-align: center;\n  color: var(--footer-medium-gray);\n  padding: 2rem;\n}\n\n.admin-form {\n  max-width: 100%;\n  margin-bottom: 2rem;\n}\n\n.admin-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n  margin: 1rem 0;\n}\n\n.admin-form-grid input {\n  padding: 0.65rem 0.85rem;\n  border: 2px solid var(--border-light);\n  border-radius: 8px;\n  font-family: inherit;\n}\n\n.admin-status-select {\n  display: block;\n  margin-top: 1rem;\n  font-weight: 600;\n}\n\n.admin-status-select select {\n  display: block;\n  width: 100%;\n  margin-top: 0.35rem;\n  padding: 0.5rem;\n  border-radius: 8px;\n  border: 2px solid var(--border-light);\n  font-family: inherit;\n}\n\n.admin-page .portal-inner {\n  max-width: 960px;\n}\n\n.portal-loading {\n  text-align: center;\n  padding: 4rem 1rem;\n  color: var(--footer-medium-gray);\n  font-size: 1.1rem;\n}\n\n.portal-info {\n  color: #047857;\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n  text-align: center;\n}\n\n.portal-forgot {\n  display: block;\n  width: 100%;\n  margin-top: 0.75rem;\n  background: none;\n  border: none;\n  color: var(--button-medium-blue);\n  cursor: pointer;\n  font-family: inherit;\n  text-decoration: underline;\n}\n\n.portal-toolbar {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.portal-toolbar input,\n.portal-toolbar select {\n  padding: 0.7rem 0.9rem;\n  border: 2px solid var(--border-light);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 0.95rem;\n}\n\n.portal-detail-link {\n  display: inline-block;\n  margin-top: 1rem;\n  text-decoration: none;\n}\n\n.portal-detail {\n  max-width: 860px;\n}\n\n.portal-back-inline {\n  display: inline-block;\n  margin-bottom: 1.25rem;\n  color: var(--button-medium-blue);\n  text-decoration: none;\n}\n\n.portal-detail-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.portal-detail-title {\n  margin: 0.2rem 0 0;\n  font-size: 1.75rem;\n  color: var(--primary-dark-blue);\n}\n\n.portal-detail-meta {\n  margin-bottom: 1.5rem;\n}\n\n.portal-status-badge-lg {\n  font-size: 1rem;\n  padding: 0.4rem 1rem;\n}\n\n.highlight-update {\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n.admin-edit-btn {\n  margin-top: 0.75rem;\n}\n\n.admin-edit-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.6rem;\n  margin: 0.75rem 0;\n}\n\n.admin-edit-grid input,\n.admin-status-select input {\n  width: 100%;\n  margin-top: 0.35rem;\n  padding: 0.55rem 0.75rem;\n  border: 2px solid var(--border-light);\n  border-radius: 8px;\n  font-family: inherit;\n}\n\n.document-panel {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-light);\n}\n\n.document-panel-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 0.75rem;\n}\n\n.document-panel-head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n}\n\n.document-upload-btn {\n  cursor: pointer;\n}\n\n.document-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.document-item {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n  padding: 0.85rem 1rem;\n  background: var(--section-light-gray);\n  border-radius: 10px;\n}\n\n.document-actions {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 640px) {\n  .portal-toolbar {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
